import { Controller } from "stimulus";
import { Turbo } from '@hotwired/turbo-rails';
import flatpickr from "flatpickr";
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import Swal from 'sweetalert2';
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import 'select2';
import 'select2/dist/css/select2';
import 'flatpickr/dist/flatpickr.min.css';
import EnrollmentContractService from "../entrypoints/src/admin/services/enrollment-contract-service";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

export default class extends Controller {
  static targets = [
    'form',
    'entryCard',
    'selectPrice',
    'selectService',
    'selectBatch',
    'contractName',
    'digitalContractSelected',
    'selectContract',
    'digitalContractModal'
  ];

  static values = {
    'uid': String,
    'selectedSchedules': Array,
    'oste': Boolean
  };

  keepAttributesCallbacks = {
    'tuitions_value': ($target) =>{
      let _self = this;
      return new Promise((resolve, reject) => {
        let keepDebit = _self.element.querySelector('#enrollment-contract--keep-period-value-cents');

        if ($target.dataset.value == $target.value.replace(/\D/g, ''))
          return reject('not value changed');

        sweet_alert.fire({
          width: '540px',
          text: 'Como deseja ratear a diferança dos valores das mensalidades?',
          showCancelButton: true,
          confirmButtonText: 'Tirar a diferença de trás para frente',
          cancelButtonText: 'Distribuir a diferença igualmente',
          denyButtonText: 'Recalcular saldo devedor',
          showDenyButton: true
        }).then((resp) => {
          let strategy = resp.isConfirmed ? 'backward' : 'spread';

          if (resp.isDenied) {
            strategy = 'update-debit-value';
          }

          this.formTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="enrollment_contract[tuitions_value_strategy]" value="${strategy}" />`);
          resolve('');
        });
      })
    },
    'period_amount_attendances': () => {
      let _self = this;
      return new Promise((resolve, _) => {
        let keepAttributeValue = _self.element.querySelector('input.keep-attribute').value;

        sweet_alert.fire({
          text: 'Deseja manter a data do fim do período com a mesma quantidade de aulas selecionada?',
          showCancelButton: true,
          confirmButtonText: 'Manter Fim do Período',
          cancelButtonText: 'Recalcular Fim do Período'
        }).then((resp) => {
          resolve(resp.isConfirmed ? 'period_end_date_and_amount_attendances' : 'period_amount_attendances');
        });
      })
    }
  }

  connect() {
    AjaxLoader.hide();

    if (typeof this.element.dataset.persisted === 'string')
      return this.showSuccessAndRedirect(this.element.dataset.persisted);

    $(this.element).find('.select2').select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: false,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.querySelector('.modal-dialog.modal-fullscreen .modal-body')
    });

    this.updateObjectService();

    $(this.element.querySelectorAll('.modal')).on('keypress',  (ev) => {
      if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
        ev.preventDefault();
      }
    });

    $('[data-submit-form="change"]').on('change', (ev) => this.updateObjectService() & this.submitForm(ev));
    $('[data-edit-contract-part]').on('click', (ev) => this.submitForm(ev));
    $('#batch-appointemnts-modal').on('hidden.bs.modal', (ev) => this.submitForm(ev));
    this.hasSelectPriceTarget && $(this.selectPriceTarget).on('change', (ev) => this.updatePrice(ev));
    this.hasSelectContractTarget && $(this.selectContractTarget).on('click', (ev) => this.onSelectContract(ev));
    this.element.querySelectorAll('.disabled').forEach(($el) => $el.setAttribute('disabled', ''));
    this.element.querySelectorAll('.date-picker.submit-form:not(.disabled)').forEach(($el) => {
      $el.dataset.dateStr = $el.value;
      flatpickr($el, {
        "dateFormat": ($el.dataset.format || "d/m/Y"),
        "altFormat": ($el.dataset.altFormat || "F j, Y"),
        "altInput": !!$el.dataset.altFormat,
        "locale": Portuguese,
        "allowInput": ($el.dataset.allowInput || true),
        "time_24hr": true,
        "onChange": (_, dateStr) => {
          $el.dataset.dateStr != dateStr && this.submitForm({ currentTarget: $el })
        }
      });
    });

    this.osteValue && this.openSchedules();
  }

  onDestroyContract(ev) {
    ev.preventDefault();
    Swal.fire({
      title: 'Atenção',
      icon: 'warning',
      html: 'Deseja realmente excluir esse contrato permanentemente?',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      focusConfirm: false,
      confirmButtonText: 'Sim',
      showCancelButton: true
    }).then((resp) => {
      if (!resp)
        return;

      let htmlForm = `
        <form action="${ev.target.getAttribute('href')}" method="delete">
          <input type="hidden" name="_method" value="delete" />
          <button class="hidden destroy-contract"></button>
        </form>
      `;
      this.element.insertAdjacentHTML('afterbegin', htmlForm);
      this.element.querySelector('form button.destroy-contract').click();
    });
  }

  showSuccessAndRedirect(redirectTo) {
    Swal.fire('Pronto', 'Contrato atualizado com sucesso', 'success').then(() => {
      Turbo.visit(redirectTo);
    });
  }

  onSelectContract() {
    this.contractNameTarget.innerHTML = this.digitalContractSelectedTarget.selectedOptions[0].text;
    this.hasDigitalContractModalTarget && $(this.digitalContractModalTarget).modal('hide');
  }

  updatePrice(ev) {
    let contractSchedulesFields = this.formTarget.querySelector('.contract-schedules');
    !!contractSchedulesFields && (contractSchedulesFields.innerHTML = ''); // clear all possible selection schedules
    this.submitForm(ev);
  }

  updatePriceBatchCompositionRef() {
    let objectService = this.selectPriceTarget.selectedOptions[0].dataset.objectPriceComposition || 'price_id',
      objectValueId = this.selectPriceTarget.value
    this.formTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${this.entryCardTarget.dataset.objectName}[${objectService}]" value="${objectValueId}" />`);
  }

  updateObjectService() {
    let objectService = this.selectServiceTarget.selectedOptions[0].dataset.objectService || 'service_id',
      objectValueId = this.selectServiceTarget.value;

    if (objectService === 'service_id') {
      this.element.querySelectorAll('.enrollment-contract-batch').forEach(($el) => $el.remove());
    } else if (objectService === 'batch_id' && this.hasSelectBatchTarget) {
      objectValueId = this.selectBatchTarget.value;
    }

    this.formTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${this.entryCardTarget.dataset.objectName}[${objectService}]" value="${objectValueId}" />`);
  }

  destroy(ev) {
    let target = ev.currentTarget;
    Swal.fire({
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-danger mr-3'
      },
      buttonsStyling: false,
      title: 'Atenção',
      html: 'Deseja realmente remover esse contrato?',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.value) {
        let response = await EnrollmentContractService.destroy(target.dataset.id);
        console.log(response)
        target.closest('.inner-card').innerHTML = response;
      }
    });
  }

  async submitForm(ev) {
    try {
      let $target = ev.currentTarget,
        keepAttribute = !!ev && ev.currentTarget.dataset.keepAttribute;

      if (!!keepAttribute) {
        !!this.keepAttributesCallbacks[keepAttribute] && (keepAttribute = await this.keepAttributesCallbacks[keepAttribute].bind(this)($target));
        this.element.querySelector('input.keep-attribute').value = keepAttribute;
      }

      if (!!$target.dataset.editContractPart)
        this.formTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="edit-part" value="${$target.dataset.editContractPart}" />`);

      if (this.hasSelectPriceTarget)
        this.updatePriceBatchCompositionRef();

      this.formTarget.insertAdjacentHTML('beforeend', this.appendCustomParam($target));
      this.formTarget.insertAdjacentHTML('beforeend', '<button class="hidden" id="formSubmissionTrigger">submit</button>');
      this.formTarget.insertAdjacentHTML('beforeend', '<input type="hidden" value="keep" name="up" />');
      AjaxLoader.show();
      setTimeout(() => this.element.querySelector('#formSubmissionTrigger').click());
    } catch (e) {
      console.error(e);
    }
  }

  appendCustomParam(element) {
    if (!element.dataset.customParam)
      return '';

    return element.dataset.customParam.split(';').map((it) => {
      let att = it.split('=');
      return `<input type="hidden" name="${att[0]}" value="${att[1] == '{{value}}' ? element.value : att[1]}" />`
    }).join('');
  }

  saveSchedules(ev) {
    this.formTarget.querySelector('.contract-schedules').innerHTML = [...document.querySelectorAll('.schedule-board-modal .card.selected-schedule, .schedule-board-modal .card.selected-batch-schedule')].map(
      ($el) => [...$el.querySelectorAll('.object-values')]
    ).flat().map((node) => node.outerHTML).join('');

    this.formTarget.insertAdjacentHTML('beforeend', '<input type="hidden" name="updated-schedules" value="on" />');

    this.submitForm(ev);
  }

  save(ev) {
    if (this.hasSelectPriceTarget)
      this.updatePriceBatchCompositionRef();
  }

  async openSchedules(ev) {
    await this.element.querySelector('turbo-frame.schedule-calendar').loaded

    let modal = this.element.querySelector('.schedule-board-modal'),
      $el = modal.querySelector('.modal-body'),
      form = $el.querySelector('.calendar-form'),
      set = new Set(this.selectedSchedulesValue.map((it) => it.level_id)),
      $target = ev.currentTarget;

    this.formTarget.insertAdjacentHTML('beforeend', this.appendCustomParam($target));

    form.insertAdjacentHTML('beforeEnd', `
      <input type="hidden" name="keep_selection" value="true" />
      <input type="hidden" name="service_id" value="${this.selectServiceTarget.value}" />
      <input type="hidden" name="price_id" value="${this.selectPriceTarget.value}" />
      <input type="hidden" name="object_name" value="${this.element.dataset.schedulesObjectName}" />
      <input type="hidden" name="selected_schedules" value='${JSON.stringify(this.selectedSchedulesValue)}' />
      ${set.size == 1 ? `<input type="hidden" name="level_id" value="${set.keys().next().value}" />` : ''}
      <button class="hidden" id="submit-form-programmatically"></button>
    `);
    form.querySelector('#submit-form-programmatically').click();

    $(modal).modal('show');
  }

  toSnakeCase(string) {
    return string.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
  }

  disconnect() {
    this.element.querySelectorAll('.date-picker, .with-date-picker').forEach(($el) => !!$el._flatpickr && $el._flatpickr.destroy());
  }
}